import { render, staticRenderFns } from "./AddPolicyModal.vue?vue&type=template&id=41fd338d"
import script from "./AddPolicyModal.vue?vue&type=script&lang=js"
export * from "./AddPolicyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports